export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProjectDetailsChild.vue?vue&type=template&id=3fb3779a&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ProjectDetailsChild.vue?vue&type=template&id=3fb3779a&scoped=true&
// module id = 340
// module chunks = 0